import { module } from 'modujs';
import { html } from '../utils/environment';

const CLASS_MODAL = 'has-modal-open';

export default class Modal extends module {

    constructor(m) {
        super(m);

        this.$el = this.el

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    open() {
        html.classList.add('has-modal-open');
        this.$el.setAttribute('aria-hidden', false)
        this.bindKeyPress()
    }

    close() {
        html.classList.remove(CLASS_MODAL);
        this.$el.setAttribute('aria-hidden', true)
    }

    bindKeyPress() {
        document.addEventListener('keyup', this.onKeyUp = e => {
            if (e.code === 'Escape' || e.code === 'Space') {
                e.preventDefault()
                this.close()

                setTimeout(() => {
                    this.call('destroyInitClickedSwiper', null, 'Carousel')
                }, 600)
               
            }
        })
    }

    unbindKeyPress() {
        document.removeEventListener('keyup', this.onKeyUp)
    }

    destroy() {
        this.unbindKeyPress()
    }
}
